// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_discovery_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Karl Muller, Dipl. Ing. ETH, suffered from chronic back and joint pain for years. Nothing helped — until South Korea. Walking barefoot on soft, waterlogged paddies, his body began to heal. The unstable ground activated forgotten muscles. Each step was cushioned. Each stride, therapeutic.`
};

const el_tech_discovery_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Ο Karl Muller, Dipl. Ing. ETH, υπέφερε από χρόνιους πόνους στη μέση και τις αρθρώσεις για χρόνια. Τίποτα δεν βοηθούσε — μέχρι τη Νότια Κορέα. Περπατώντας ξυπόλητος σε μαλακούς, πλημμυρισμένους ορυζώνες, το σώμα του άρχισε να αναρρώνει. Το ασταθές έδαφος ενεργοποίησε ξεχασμένους μύες. Κάθε βήμα ήταν μαλακό. Κάθε βηματισμός, θεραπευτικός.`
};

const ru_tech_discovery_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Karl Muller, Dipl. Ing. ETH, годами страдал от хронических болей в спине и суставах. Ничего не помогало — пока он не оказался в Южной Корее. Ходьба босиком по мягким, затопленным рисовым полям запустила процесс восстановления. Нестабильная поверхность активировала забытые мышцы. Каждый шаг был мягким. Каждый шаг — терапией.`
};

const he_tech_discovery_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Karl Muller, Dipl. Ing. ETH, סבל מכאבי גב ומפרקים כרוניים במשך שנים. שום דבר לא עזר — עד דרום קוריאה. הליכה יחפה על שדות אורז רכים ומוצפים החלה לרפא את גופו. הקרקע הלא יציבה הפעילה שרירים שנשכחו. כל צעד היה מרופד. כל פסיעה — טיפולית.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_discovery_body1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_discovery_body1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_discovery_body1", locale)
	if (locale === "en") return en_tech_discovery_body1(inputs)
	if (locale === "el") return el_tech_discovery_body1(inputs)
	if (locale === "ru") return ru_tech_discovery_body1(inputs)
	if (locale === "he") return he_tech_discovery_body1(inputs)
	return "tech_discovery_body1"
};